import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "marriage",
  "use": "marriage-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"marriage\"><path d=\"M10.99 5.16c-.74 1.142-1.193 2.365-1.221 3.354-.013.46.17.942.478 1.257.438.447 1.05.447 1.486 0 .309-.315.492-.797.479-1.257-.028-.989-.482-2.212-1.222-3.355zM5.7 1.616c-3.001 0-4.07 2.298-4.07 4.448 0 4.069 6.36 9.683 9.361 11.933 3.001-2.25 9.363-7.864 9.363-11.933 0-2.15-1.07-4.448-4.071-4.448-1.422 0-2.943.793-4.244 2.196 1.096 1.52 1.76 3.221 1.801 4.655a3.395 3.395 0 0 1-.938 2.43c-.522.534-1.2.827-1.91.827-.711 0-1.39-.293-1.91-.826a3.397 3.397 0 0 1-.94-2.43c.041-1.435.705-3.136 1.802-4.656C8.642 2.41 7.121 1.617 5.699 1.617zM10.99 20l-.475-.34C10.085 19.352 0 12.07 0 6.065 0 2.437 2.29 0 5.699 0c1.82 0 3.71.922 5.291 2.56C12.572.921 14.462 0 16.282 0c3.409 0 5.699 2.437 5.699 6.065 0 6.006-10.085 13.287-10.515 13.595l-.476.34z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/marriage.svg
// module id = 1554
// module chunks = 0